import { StyledCard } from '@app/components/StyledCard';
import { ContentAiIcon } from '@app/modules/content-ai/ContentAiIcon';
import { useIntl } from 'react-intl';
import { Page } from '../../../../../components/page/Page';
import { AdminModule } from '../../../index';
import { StationConfigForm } from './StationConfigForm';

export const AdminContentAiPage = () => {
  const { $t } = useIntl();

  const title = $t({
    id: 'contentAi.configTitle',
    defaultMessage: 'Content AI config',
  });

  return (
    <Page htmlTitle={title}>
      <Page.Header
        icon={<ContentAiIcon />}
        title={title}
        breadcrumbs={<Page.ModuleBreadcrumbs module={AdminModule} />}
      />
      <Page.Content>
        <StyledCard
          title={$t({
            id: 'contentAi.configPerStation',
            defaultMessage: 'Config por emisora',
          })}
        >
          <StationConfigForm />
        </StyledCard>
      </Page.Content>
    </Page>
  );
};
